module.exports = __webpack_public_path__ + "img/two_banner_mobile_bg5.55056d51.jpg";